// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1PtEv","content":"styles_content__1Pks5","checkbox":"styles_checkbox__3fYdW","checkboxLabel":"styles_checkboxLabel__3LKry"};